import React from "react";
import { IStyledSVGIconProps, StyledSVGIcon } from "./icon.style";

export const ServiceAccountIcon: React.FC<IStyledSVGIconProps> = (props) => {
  return (
    <StyledSVGIcon
      version="1.1"
      id="icons"
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
      height="24"
      width="24"
      x="0px"
      y="0px"
      viewBox="0 0 42.3 48.4"
      style={{ enableBackground: "new 0 0 42.3 48.4" }}
      xmlSpace="preserve"
      {...props}
    >
      <path d="m0,19.19c0,10.63,8.56,19.19,19.19,19.19s19.19-8.56,19.19-19.19S29.82,0,19.19,0,0,8.56,0,19.19ZM19.19,2.95c9.01,0,16.24,7.23,16.24,16.24,0,4.87-2.21,9.45-5.9,12.55v-2.21c0-3.1-2.21-5.31-5.17-6.35,1.48-1.33,2.21-3.25,2.21-5.17v-1.92c0-3.99-3.1-7.09-7.09-7.23h-.3c-3.99-.15-7.23,2.95-7.38,6.79v2.21c0,1.92.74,3.84,2.21,5.17-2.95,1.18-5.17,3.25-5.17,6.35v2.21C1.92,25.83,1.03,15.65,6.64,8.71c3.1-3.54,7.68-5.76,12.55-5.76Z" />
    </StyledSVGIcon>
  );
};
